
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"viewBox":"0 0 91 91","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('g',{attrs:{"clip-path":"url(#clip0_1285_61259)","stroke-width":"3","stroke-linecap":"round","stroke-linejoin":"round"}},[_c('path',{attrs:{"d":"M13.333 71.278h63.334c3.498 0 6.333-2.984 6.333-6.666V17.945c0-3.682-2.835-6.667-6.333-6.667H13.333C9.836 11.278 7 14.263 7 17.945v46.667c0 3.682 2.836 6.666 6.333 6.666zM57.5 86.278h-24","stroke":"#fff"}}),_c('path',{attrs:{"d":"M57 41.278l-18-12v24l18-12z","stroke":"currentColor"}})]),_c('defs',[_c('clipPath',{attrs:{"id":"clip0_1285_61259"}},[_c('path',{attrs:{"fill":"#fff","transform":"translate(.5 .778)","d":"M0 0h90v90H0z"}})])])])
          )
        }
      }
    